import useConfiguredCurrency from '@/hooks/useConfiguredCurrency';
import { getLanguage } from '@/i18n';

const localeMap: Record<string, string> = {
  en: 'en-US',
  it: 'it-IT',
};

const useLocalizedCurrencyFormatter = () => {
  const { currency } = useConfiguredCurrency();
  const i18nLanguage = getLanguage();

  return new Intl.NumberFormat(localeMap[i18nLanguage], {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
  });
};

export default useLocalizedCurrencyFormatter;
